import React = require("react");

import { Activity, fieldValidation, PublicAmorgUser } from "../../../amorg-common";
import { updateActivity } from "../../../api/activityClientApi";
import { Flex } from '../../../designSystem/compositeComponents/FlexHelpers';
import { DateTimeStartEndFields } from "../../../designSystem/formField/DateTimeStartEndFields";
import { FormField } from "../../../designSystem/formField/FormField";
import { TextSaveField } from "../../../designSystem/formField/text/TextSaveField";
import { TextAreaSaveField } from "../../../designSystem/formField/textArea/TextAreaSaveField";
import { StartEndDateFields } from "../../../designSystem/inputs/StartEndDateFields";
import { ErrorMessage } from "../../../designSystem/Message";
import { PageSectionHeader } from "../../../designSystem/PageSectionHeader";
import { ActivityParticipantList } from "../participants/ActivityParticipantList";


type ActivityDetailsPanelProps = {
    componentTitle?: string,
    activity: Activity;
    periodSelection: 'date-time' | 'date',
    infoComponents?: React.ReactNode,
    extraComponents?: React.ReactNode,
    titleText?: string,
    descriptionText?: string,
    users: PublicAmorgUser[],
    participantTexts?: { header: string };
    onActivityUpdated: () => void;
};
export function ActivityDetailsPanel (props: ActivityDetailsPanelProps)
{

    const [dateError, setDateError] = React.useState(false);

    async function handleUpdateDates (start: Date, end: Date)
    {
        performUpdate((activity) =>
        {
            activity.start = start;
            activity.end = end;
        });
    }


    async function performUpdate (mutator: (activity: Activity) => void)
    {
        //const a = await getActivity(initialActivity.id);
        mutator(props.activity);
        const result = await updateActivity(
            props.activity.id,
            props.activity.title,
            props.activity.description,
            props.activity.start,
            props.activity.end,
            props.activity.location
        );
        if (result.errorMessage === 'updateActivity_end_dependency_violated' || result.errorMessage === 'updateActivity_start_dependency_violated')
            setDateError(true);
        else
            setDateError(false);

        props.onActivityUpdated();

        return result;
    }

    const periodSelection = props.periodSelection || 'date-time';

    return (

        <Flex flexDirection="column" gap={16}>


            {props.activity &&
                <>
                    <Flex flexDirection="row" gap={24}>

                        {props.infoComponents}

                        <Flex flexDirection="row" gap={24} alignItems="flex-start" width="100%">

                            {(props.activity.activityType === "WorkgroupMeeting" || props.activity.activityType === "AnnualWorkgroupStatus") &&
                                <Flex flexDirection="column" width="100%">
                                    <TextSaveField
                                        trailingIcon={"interface_glyph_location"}
                                        label={"Sted"}
                                        value={props.activity.location}
                                        onSave={newValue =>
                                        {
                                            if (fieldValidation.activity.location(newValue))
                                                performUpdate((a) => { a.location = newValue; });
                                        }}
                                        validator={(currentValue) =>
                                            fieldValidation.activity.location(currentValue)
                                                ? { valid: true }
                                                : { valid: false, errorMessage: 'Ugyldig beskrivelse. Maks. 200 tegn.' }
                                        }
                                    />
                                </Flex>
                            }

                            <Flex flexDirection="row">
                                {periodSelection === 'date-time' &&
                                    <DateTimeStartEndFields
                                        start={props.activity.start}
                                        end={props.activity.end}
                                        onChanged={handleUpdateDates}
                                        layoutDirection="row"
                                        hideLabels={false}
                                    />
                                }

                                {periodSelection === 'date' &&
                                    <FormField
                                        label={"Periode"}
                                        inputComponent={
                                            <StartEndDateFields
                                                start={props.activity.start} end={props.activity.end}
                                                onChanged={handleUpdateDates} />
                                        } />
                                }
                            </Flex>
                        </Flex>


                        {dateError &&
                            <ErrorMessage show={true}>Du har valgt en ugyldig kombination af datoer. Besvarelsesperioden for spørgeskemaet skal ligge indenfor den valgte APV-periode.</ErrorMessage>
                        }

                        {props.extraComponents}


                    </Flex>

                    {props.participantTexts &&
                        <FormField
                            label={props.participantTexts.header}
                            inputComponent={
                                <>
                                    <ActivityParticipantList
                                        activity={props.activity}
                                        users={props.users}
                                        onParticipantsUpdated={props.onActivityUpdated} />
                                </>
                            } />
                    }

                    <PageSectionHeader styleVariant="dark">
                        Mødebeskrivelse
                    </PageSectionHeader>
                    <TextAreaSaveField
                        label={props.descriptionText || "Beskrivelse"}
                        minRows={3}
                        value={props.activity.description}
                        onSave={newValue =>
                        {
                            if (fieldValidation.activity.description(newValue))
                                performUpdate((a) => { a.description = newValue; });
                        }}
                        validator={(currentValue) =>
                            fieldValidation.activity.description(currentValue)
                                ? { valid: true }
                                : {
                                    valid: false, errorMessage: `Ugyldig beskrivelse. Maks. 10000 tegn (${currentValue.length}).`
                                }}
                    />
                    
                </>
            }
        </Flex>
    );
}